import { IGoodInventory } from "@lib";
import * as filters from "@/filters";

export function getDefaultTableColumns(context: any): any[] {
    return [
        {
            colId: "actions",
            headerName: "Изменить / Удалить",
            width: 70 + (context.can.update ? 25 : 0) + (context.can.delete ? 25 : 0),
            minWidth: 70 + (context.can.update ? 25 : 0) + (context.can.delete ? 25 : 0),
            hide: false,
            headerClass: "text-transparent",
            headerCheckboxSelection: true,
            checkboxSelection: true,

            cellRendererFramework: "CellRendererActions",
            cellRendererParams: (params: any) => {
                return {
                    actions: [
                        {
                            id: "edit",
                            description: "Изменить",
                            icon: "Edit3Icon",
                            classes: "h-1 w-1 mr-0.75 hover:text-primary cursor-pointer",
                            isVisible: (goodInventory: IGoodInventory) => context.can.update(goodInventory),
                            click: (goodInventory: IGoodInventory) => context.showModalUpdate(goodInventory),
                        },
                        {
                            id: "delete",
                            description: "Удалить",
                            icon: "Trash2Icon",
                            classes: "h-1 w-1 mr-0.75 hover:text-danger cursor-pointer",
                            isVisible: (goodInventory: IGoodInventory) => context.can.delete(goodInventory),
                            click: (goodInventory: IGoodInventory) => context.confirmDelete(goodInventory),
                        },
                    ],
                };
            },
        },
        {
            colId: "number",
            field: "number",
            headerName: "#",
            sortable: true,
            filter: true,
            width: 100,
            hide: false,
        },
        {
            colId: "store",
            field: "store",
            headerName: "Склад",
            sortable: true,
            filter: true,
            width: 175,
            hide: false,

            cellRendererFramework: "CellRendererChip",
            cellRendererParams: (params: any) => {
                return {
                    name: params.data.storeRef?.info.name,
                };
            },
        },
        {
            colId: "status",
            field: "status",
            headerName: "Статус",
            sortable: true,
            filter: true,
            width: 150,
            hide: false,

            cellRendererFramework: "CellRendererChip",
            cellRendererParams: (params: any) => {
                return {
                    name: params.data.done ? "Завершена" : "В работе",
                    color: params.data.done ? "#cccccc" : "#7ece65",
                };
            },
        },
        {
            colId: "employee",
            field: "employee",
            headerName: "Сотрудник",
            sortable: true,
            filter: true,
            width: 220,
            hide: false,

            cellRendererFramework: "CellRendererAvatar",
            cellRendererParams: (params: any) => {
                const employee = params.data.employeeRef;

                return {
                    showAvatar: true,
                    avatar: employee?.info.avatar ?? "",
                    name: employee?.info.name ?? "",
                };
            },
        },
        {
            colId: "comment",
            field: "comment",
            headerName: "Комментарий",
            sortable: true,
            filter: true,
            width: 500,
            hide: false,
        },
        {
            colId: "doneAt",
            field: "doneAt",
            headerName: "Дата завершения",
            sortable: true,
            filter: true,
            width: 200,
            hide: false,

            cellRenderer: function (params: any) {
                return params.value ? filters.datetime.datetime(params.value, "L LT") : "";
            },
        },
    ];
}
